import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

import { Option } from '@joor/design-system'

import { ImportOrdersContext } from './ImportOrders.context'

export type ImportOrdersVerticalHorizontalContextProps = {
  billingAddress?: Option
  setBillingAddress: Dispatch<SetStateAction<Option | undefined>>
  billingAddressOptions: Option[]
  setBillingAddressOptions: Dispatch<SetStateAction<Option[]>>
  clearSecondStepVerticalHorizontalValues: () => void
  linesheet?: Option
  setLinesheet: Dispatch<SetStateAction<Option | undefined>>
  linesheetOptions: Option[]
  setLinesheetOptions: Dispatch<SetStateAction<Option[]>>
  orderStatus: Option | null
  setOrderStatus: Dispatch<SetStateAction<Option | null>>
  paymentMethod?: Option
  setPaymentMethod: Dispatch<SetStateAction<Option | undefined>>
  paymentMethodOptions: Option[]
  setPaymentMethodOptions: Dispatch<SetStateAction<Option[]>>
  priceType?: Option
  setPriceType: Dispatch<SetStateAction<Option | undefined>>
  priceTypeOptions: Option[]
  setPriceTypeOptions: Dispatch<SetStateAction<Option[]>>
  shippingAddress?: Option
  setShippingAddress: Dispatch<SetStateAction<Option | undefined>>
  shippingAddressOptions: Option[]
  setShippingAddressOptions: Dispatch<SetStateAction<Option[]>>
  shippingMethod?: Option
  setShippingMethod: Dispatch<SetStateAction<Option | undefined>>
  shippingMethodOptions: Option[]
  setShippingMethodOptions: Dispatch<SetStateAction<Option[]>>
}

const ImportOrdersVerticalHorizontalContext =
  createContext<ImportOrdersVerticalHorizontalContextProps>(
    {} as ImportOrdersVerticalHorizontalContextProps,
  )

type ImportOrdersVerticalHorizontalContextProviderProps = {
  children: ReactNode
}
const ImportOrdersVerticalHorizontalContextProvider: FC<
  ImportOrdersVerticalHorizontalContextProviderProps
> = ({ children }) => {
  const [billingAddress, setBillingAddress] = useState<Option>()
  const [billingAddressOptions, setBillingAddressOptions] = useState<Option[]>(
    [],
  )
  const [linesheet, setLinesheet] = useState<Option>()
  const [linesheetOptions, setLinesheetOptions] = useState<Option[]>([])
  const [orderStatus, setOrderStatus] = useState<Option | null>(null)
  const [paymentMethod, setPaymentMethod] = useState<Option>()
  const [paymentMethodOptions, setPaymentMethodOptions] = useState<Option[]>([])
  const [priceType, setPriceType] = useState<Option>()
  const [priceTypeOptions, setPriceTypeOptions] = useState<Option[]>([])
  const [shippingAddress, setShippingAddress] = useState<Option>()
  const [shippingAddressOptions, setShippingAddressOptions] = useState<
    Option[]
  >([])
  const [shippingMethod, setShippingMethod] = useState<Option>()
  const [shippingMethodOptions, setShippingMethodOptions] = useState<Option[]>(
    [],
  )

  const {
    setBrand,
    setConnectedAccountsOptions,
    setRetailer,
    setRetailerSearchText,
    setWarehouse,
    setOrderType,
  } = useContext(ImportOrdersContext)

  const clearSecondStepVerticalHorizontalValues = () => {
    setBrand(null)
    setConnectedAccountsOptions([])
    setRetailer(null)
    setLinesheetOptions([])
    setPriceTypeOptions([])
    setShippingAddressOptions([])
    setBillingAddressOptions([])
    setPaymentMethodOptions([])
    setShippingMethodOptions([])
    setOrderStatus(null)
    setLinesheet(undefined)
    setPriceType(undefined)
    setShippingAddress(undefined)
    setBillingAddress(undefined)
    setPaymentMethod(undefined)
    setShippingMethod(undefined)
    setWarehouse(null)
    setOrderType(null)
    setRetailerSearchText('')
  }

  return (
    <ImportOrdersVerticalHorizontalContext.Provider
      value={{
        billingAddress,
        setBillingAddress,
        billingAddressOptions,
        setBillingAddressOptions,
        clearSecondStepVerticalHorizontalValues,
        linesheet,
        setLinesheet,
        linesheetOptions,
        setLinesheetOptions,
        orderStatus,
        setOrderStatus,
        paymentMethod,
        setPaymentMethod,
        paymentMethodOptions,
        setPaymentMethodOptions,
        priceType,
        setPriceType,
        priceTypeOptions,
        setPriceTypeOptions,
        shippingAddress,
        setShippingAddress,
        shippingAddressOptions,
        setShippingAddressOptions,
        shippingMethod,
        setShippingMethod,
        shippingMethodOptions,
        setShippingMethodOptions,
      }}
    >
      {children}
    </ImportOrdersVerticalHorizontalContext.Provider>
  )
}

export {
  ImportOrdersVerticalHorizontalContext,
  ImportOrdersVerticalHorizontalContextProvider,
}
